import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import Breadcrumbs from '../../components/layout/Breadcrumbs';

// IGNORE THIS FOR NOW 

const UsersPage = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Breadcrumbs items={[
        { label: 'Administration', href: '/admin' },
        { label: 'Users' }
      ]} />
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 500, color: '#333' }}>
          User Management
        </Typography>
      </Box>
      
      <Paper sx={{ p: 3, textAlign: 'center', borderRadius: 2 }} elevation={0}>
        <Typography variant="body1">
          User management functionality will be implemented here.
        </Typography>
      </Paper>
    </Box>
  );
};

export default UsersPage;
